import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AIChatbotSettingsTrainingTabFile from "./AIChatbotFileTrainingIndex";
import AIChatbotTrainingSettingsTabs from "./AIChatbotTrainingSettingsTab";
import AIChatbotWebTrainingIndex from "./AIChatbotWebTrainingIndex";
import { PrimaryBlueButton, Severity } from "@velaro/velaro-component-lib";
import useToastAlert from "@/hooks/useToastAlert";
import useApi from "@/hooks/useApi";

interface WizardReturn {
  integration: string;
  integrationLabel: string;
  workflowId: number | null;
  returnPath: string;
  savedAt: number;
}

export default function AIChatbotWebTraining() {
  const [pythonOutput, setPythonOutput] = useState<string>("");
  const [wizardReturn, setWizardReturn] = useState<WizardReturn | null>(null);
  const toastAlert = useToastAlert();
  const api = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const raw = localStorage.getItem("velaro_wizard_return");
      if (!raw) return;
      const data: WizardReturn = JSON.parse(raw);
      // Show banner only if set within the last 2 hours
      if (data.savedAt && Date.now() - data.savedAt < 2 * 60 * 60 * 1000) {
        setWizardReturn(data);
      } else {
        localStorage.removeItem("velaro_wizard_return");
      }
    } catch {}
  }, []);

  function handleBackToWizard() {
    localStorage.removeItem("velaro_wizard_return");
    navigate(wizardReturn?.returnPath || "/integrations");
  }

  async function runPythonScript() {
    const result = await api.messaging.post(`WebScraping/RunPythonScript`);
    const response = await result.text();
    if (result.ok) {
      toastAlert.displayToast(
        Severity.Success,
        "Python script ran successfully"
      );
      setPythonOutput(response);
    } else {
      toastAlert.displayToast(Severity.Error, "Failed to run python script");
    }
  }

  return (
    <div>
      {/* ── Back-to-wizard banner (shown when navigated here from wizard done step) ── */}
      {wizardReturn && (
        <div className="mb-4 rounded-lg border border-indigo-200 bg-indigo-50 px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-sm text-indigo-700">
            <i className="fa-solid fa-wand-magic-sparkles text-indigo-400" />
            <span>
              Setting up your <strong>{wizardReturn.integrationLabel}</strong> bot — add your website URL below, then continue setup when ready.
            </span>
          </div>
          <button
            type="button"
            onClick={handleBackToWizard}
            className="flex-shrink-0 flex items-center gap-1.5 text-xs font-semibold text-indigo-700 hover:text-indigo-900 bg-indigo-100 hover:bg-indigo-200 px-3 py-1.5 rounded-lg transition-colors whitespace-nowrap"
          >
            <i className="fa-solid fa-arrow-left text-xs" />
            Continue setup
          </button>
        </div>
      )}
      <AIChatbotTrainingSettingsTabs selectedTab={"Web Training"} />
      <div className="flex items-center justify-center">
        <div className="bg-white p-6 border-[1px] rounded-2xl shadow-sm w-3/4 self-center ">
          <AIChatbotWebTrainingIndex />
        </div>
      </div>
      {/* <div className="flex flex-row justify-center mt-4">
        <div className="pt-4 border-[1px] p-6 shadow-sm rounded-2xl flex flex-col w-[725px]">
          <PrimaryBlueButton
            label="Python Script Testing"
            onClick={runPythonScript}
          />

          <div className="text-slate-500 pt-4">Python Results:</div>
          <div className="text-black whitespace-pre-line">{pythonOutput}</div>
        </div>
      </div> */}
    </div>
  );
}
